module.exports = __webpack_public_path__ + "static/media/แบบคำขอเปิดใช้งานระบบฯ.b88ecdf0.pdf";